import { ButtonGroup, Classes, H6, Intent, Tag } from "@blueprintjs/core";
import { Form, Input } from "decorator-form";
import React from "react";
import { Entity, Field } from "typegraph";

import CountResult from "common/entities/CountResult";
import { ID } from "common/entities/IEntity";
import InputType from "common/form/InputType";
import { IPageableListQuery } from "common/models/IPageableListQuery";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { EntityTable } from "core/components/EntityTable";
import Label from "core/components/label/Label";
import constants from "../../constants";
import entityMeta from "../../entityMeta";

@Entity(entityMeta.CATEGORY)
@Form()
class Category {

	@Field()
	public id: ID;

	@Field()
	@Input({
		type: InputType.TEXT,
		title: "Name",
		required: true
	})
	public name: string;

	@Field()
	@Input({
		type: InputType.NUMBER_POSITIVE,
		title: "Sort Index"
	})
	public sortIndex: number;

	@Input({
		type: InputType.UPLOAD_URL_IMAGE,
		title: "Icon"
	})
	public tempIconUrl: string;

	@Field()
	public iconUrl: string;

	@Field()
	@Input({
		type: InputType.CHECKBOX,
		title: "Published"
	})
	public published: boolean;

}

function mapQueryParams(args: any) {

	const params = {};

	Object.entries(args).forEach(([key, value]) => {

		if (value) {
			params[key] = value;
		}
	});

	return { params };
}

class CategoryQuery implements IPageableListQuery<Category> {

	@Field({
		entity: Category,
		aliasFor: "kbCategory_many",
		params: mapQueryParams
	})
	public entities: null | Category[];

	@Field({
		entity: CountResult,
		aliasFor: "kbCategory_count",
		params: mapQueryParams
	})
	public count: CountResult;

}

interface ICategoryListProps {
	knowledgeBaseId: ID;
	parentId?: ID;
	topLevel?: boolean;
}

export default function CategoryList(props: ICategoryListProps) {

	const params = {};

	if (props.knowledgeBaseId) {
		params['knowledgeBaseId'] = props.knowledgeBaseId;
	}

	if (props.parentId) {
		params['parentId'] = props.parentId;
	}

	if (props.topLevel) {
		params['topLevel'] = true;
	}

	return (
		<EntityTable
			pagingQuery={CategoryQuery}
			formClass={Category}
			params={params}
			columns={[
				{
					key: 'name',
					label: 'Name',
					sort: 'name',
					renderCell: ({data}) => (
						<PageLinkView
							viewKey="category.link"
							preserveParams={false}
							params={{
								[constants.PARAM_CATEGORY_ID]: data.id
							}}
						>
							<H6>{data.name}</H6>
						</PageLinkView>
					)
				},
				{
					key: 'sortIndex',
					label: 'Sort Index',
					sort: 'sortIndex',
					renderCell: ({data}) => (data.sortIndex).toString()
				},
				{
					key: 'status',
					label: 'Status',
					sort: 'published',
					renderCell: ({data}) => (
						<Tag minimal={true} intent={data.published ? Intent.PRIMARY : Intent.WARNING}>
							{
								data.published ? (
									<Label k="category.published" v="Published" />
								) : (
									<Label k="category.not.published" v="Not Published" />
								)
							}
						</Tag>
					)
				}

			]}
			onBeforeSave={
				(category) => {

					const actionParams = {};

					if (category.id) {
						actionParams['id'] = category.id;
					} else {
						actionParams['knowledgeBaseId'] = props.knowledgeBaseId;
					}

					actionParams['name'] = category.name;

					if (props.parentId) {
						actionParams['parentId'] = props.parentId;
					}

					if (category.tempIconUrl && category.tempIconUrl !== category.iconUrl) {
						actionParams['iconUrl'] = category.tempIconUrl;
					}

					actionParams['sortIndex'] = category.sortIndex || 0;
					actionParams['published'] = category.published || false;

					return actionParams;
				}
			}
		/>
	);
}



// WEBPACK FOOTER //
// ./src/panels/kb/category/admin/CategoryList.tsx